/*
 * Rotates announcement messages one at a time, with optional manual controls.
 * Pauses on hover/focus and while the tab is hidden. Visitors who prefer
 * reduced motion get no auto-rotation, but the arrows still work.
 */
class NVAnnouncement extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.nv-ticker__item'));
    if (this.items.length < 2) return;

    this.index = 0;
    this.interval = parseInt(this.dataset.interval, 10) || 5000;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const prev = this.querySelector('.nv-ticker__arrow--prev');
    const next = this.querySelector('.nv-ticker__arrow--next');
    if (prev) prev.addEventListener('click', () => this.step(-1, true));
    if (next) next.addEventListener('click', () => this.step(1, true));

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    this.onVisibility = () => (document.hidden ? this.stop() : this.start());
    document.addEventListener('visibilitychange', this.onVisibility);

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  start() {
    this.stop();
    // Auto-rotation is the part reduced-motion users opt out of; arrows still work.
    if (this.reduced.matches || document.hidden) return;
    this.timer = setInterval(() => this.step(1), this.interval);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  step(direction, manual) {
    const current = this.items[this.index];
    const count = this.items.length;
    this.index = (this.index + direction + count) % count;
    const upcoming = this.items[this.index];

    current.classList.remove('is-active');
    current.setAttribute('aria-hidden', 'true');
    upcoming.classList.add('is-active');
    upcoming.removeAttribute('aria-hidden');

    // A manual click restarts the countdown, so the message just chosen
    // gets its full dwell time rather than flipping a moment later.
    if (manual) this.start();
  }
}

if (!customElements.get('nv-announcement')) {
  customElements.define('nv-announcement', NVAnnouncement);
}
